import React, { useCallback, useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import { useAppContext } from 'app/AppContext';
import DataTable from 'components/DataTable';
import { fetchArray } from 'entity';
import Perfil from 'entity/Perfil';

export default function PerfilConsulta() {
    const navigate = useNavigate();
    const [options, setOptions] = useState([]);
    const { useSetTitle, setActionsView } = useAppContext()

    useSetTitle("Perfis");

    useEffect(() => {
        const actions = [
            {
                uid: "novoForm",
                text: "Novo Usuário",
                iconName: "Add",
                sequence: "10",
                action: () => {
                    navigate("/createUser");
                },
            },

        ];

        setActionsView(actions);

        return () => {
            setActionsView([]);
        };
    }, [navigate, setActionsView]);

    const loadOptions = useCallback(async () => {
        // Carrega apenas uma vez.
        if (options.length === 0) {
            const result = await fetchArray(Perfil.getAll());
            setOptions(["", ...result]);
        }
    }, [options.length]);

    useEffect(() => {
        loadOptions();
    }, [loadOptions]);
    return (

        <Box sx={{ flex: 1, height: { xs: "100%", sm: "60vh" } }}>
            <DataTable
                columns={Perfil.searchColumns}
                rows={options}
                onRowClick={(row) => {
                    navigate("/perfil?uid=" + row.id);
                }}
                sx={{
                    "& .MuiDataGrid-row:hover": {
                        cursor: "pointer",
                    },
                    '& .MuiDataGrid-row:nth-of-type(odd)': {
                        backgroundColor: "rgba(145, 145, 145, 0.20);",
                    },
                    '& .MuiDataGrid-row:nth-of-type(even)': {
                        backgroundColor: "grey",
                    },
                }}
            />
        </Box>
    )
}
